{
  "list_editor": {
    "add": "Add",
    "remove": "Remove",
    "empty": "None added yet."
  },
  "analytics_providers_editor": {
    "empty": "No analytics providers added yet.",
    "official_badge": "Official",
    "handler": "Handler",
    "events_label": "Events",
    "add_provider": "Add provider",
    "remove_provider": "Remove provider",
    "official_providers": {
      "ga": "Google Analytics (ga)",
      "gtm": "Google Tag Manager (gtm)"
    },
    "events": {
      "add_to_cart": "Add to cart",
      "cart_update": "Cart update",
      "shopping_list_create": "Shopping list create",
      "shopping_list_load": "Shopping list load",
      "shopping_list_update": "Shopping list update",
      "shopping_list_delete": "Shopping list delete",
      "shopping_list_export": "Shopping list export",
      "csv_upload": "CSV upload",
      "quick_add": "Quick add",
      "final_stage_checkout": "Final stage checkout",
      "add_shipping_info": "Shipping update",
      "begin_checkout": "Begin checkout",
      "purchase": "Purchase",
      "view_cart": "View cart"
    }
  },
  "locale_editor": {
    "new_language": "New language",
    "locale": "Language code",
    "locale_placeholder": "e.g. en",
    "add_language": "Add language",
    "remove_language": "Remove language",
    "add_language_disabled_hint": "Choose a language for the current entry before adding another.",
    "locale_required": "Language is required",
    "locale_duplicate": "This language is already added",
    "key_required": "Key is required",
    "key_duplicate": "This key is already used"
  },
  "translations_editor": {
    "empty": "No translation overrides added yet.",
    "empty_entries": "No overrides for this language yet.",
    "key": "Key",
    "value": "Value",
    "key_placeholder": "e.g. cart.checkout.notes.label",
    "key_no_options": "No matching keys — your custom key will be used.",
    "value_placeholder": "Translated text",
    "add_translation": "Add override",
    "remove_translation": "Remove override"
  },
  "payment_methods_order_editor": {
    "empty": "No payment methods added yet.",
    "remove": "Remove",
    "methods": {
      "payment_on_account": "Payment on account",
      "payment_by_invoice": "Payment by invoice",
      "upfront_payment": "Upfront payment",
      "quote": "Quote"
    }
  },
  "account_sections_editor": {
    "empty": "No My Account sections available.",
    "visible_badge": "Visible",
    "hidden_badge": "Hidden",
    "sections": {
      "spark_slot_my_account": "Custom Slot",
      "recent_activity": "Recent Activity",
      "shopping_lists": "Shopping Lists",
      "financials": "Financials",
      "my_details": "My Details",
      "reports": "Reports",
      "address_book": "Address Book",
      "company_users": "Company Users"
    }
  },
  "checkout_elements_editor": {
    "empty": "No checkout fields added yet.",
    "add_custom": "Add custom field",
    "add_custom_disabled_hint": "Name your current custom field before adding another.",
    "version_gate": {
      "feature_label": "standard checkout fields"
    },
    "standard_badge": "Standard",
    "custom_badge": "Custom",
    "hidden_badge": "Hidden",
    "optional_badge": "Optional",
    "required_badge": "Required",
    "disabled_badge": "Disabled",
    "custom_field_fallback": "Untitled custom field",
    "name_required": "Name is required",
    "invalid_number": "Enter a valid number",
    "invalid_date": "Enter a valid date (YYYY-MM-DD)",
    "invalid_pattern": "Enter a valid regular expression",
    "invalid_file_extension": "Enter a lowercase file extension without the dot (e.g. pdf)",
    "invalid_file_size": "Enter a size (e.g. 10MB)",
    "remove": "Remove",
    "translations": "Text & labels",
    "translations_hint": "Shown to customers at checkout. Add another language if your store is translated.",
    "field_status": "Field status",
    "statuses": {
      "hidden": {
        "label": "Hidden",
        "description": "Not shown to customers at checkout."
      },
      "optional": {
        "label": "Optional",
        "description": "Shown at checkout, but customers can leave it blank."
      },
      "required": {
        "label": "Required",
        "description": "Shown at checkout and must be completed."
      },
      "disabled": {
        "label": "Disabled",
        "description": "Shown at checkout, but read-only."
      }
    },
    "standard": {
      "po_number": "PO number",
      "shipping_requested_date": "Requested shipping date",
      "customer_reference": "Customer reference"
    },
    "type_options": {
      "text": "Text",
      "text-area": "Text area",
      "number": "Number",
      "date": "Date",
      "email": "Email",
      "tel": "Phone",
      "checkbox": "Checkbox",
      "file": "File upload",
      "select": "Dropdown",
      "week": "Week",
      "url": "URL",
      "time": "Time",
      "month": "Month",
      "color": "Color"
    },
    "fields": {
      "name": "Internal name",
      "name_hint": "Identifies this field in your order data. Not shown to customers.",
      "type": "Input type",
      "title": "Title",
      "placeholder": "Placeholder",
      "detail": "Detail",
      "value": "Default value",
      "minlength": "Min length",
      "maxlength": "Max length",
      "pattern": "Pattern (RegExp)",
      "min": "Min",
      "max": "Max",
      "step": "Step",
      "min_files": "Min files",
      "max_files": "Max files",
      "maxsize": "Max file size",
      "fileextensions": "Allowed file extensions"
    },
    "placeholders": {
      "name": "e.g. delivery-notes",
      "title": "e.g. Delivery instructions",
      "detail": "e.g. Notes for our warehouse team",
      "placeholder": "e.g. Enter your VAT number",
      "minlength": "e.g. 3",
      "maxlength": "e.g. 20",
      "pattern": "e.g. [A-Za-z0-9]+",
      "min": "e.g. 0",
      "max": "e.g. 100",
      "step": "e.g. 1",
      "min_files": "e.g. 1",
      "max_files": "e.g. 5",
      "maxsize": "e.g. 5MB",
      "fileextension": "e.g. pdf"
    }
  },
  "per_locale_fields_editor": {
    "empty": "No languages added yet.",
    "messages": "Validation messages",
    "messages_hint": "Only used if a developer has added a custom validator for this field in SparkLayer's JavaScript. The key must match the one the validator returns.",
    "message_key": "Message key",
    "message_value": "Message",
    "message_key_placeholder": "e.g. required",
    "message_value_placeholder": "Message shown to the customer",
    "field_required": "{field} is required",
    "remove_message": "Remove message",
    "add_message": "Add message"
  },
  "checkout_dropdown_options_editor": {
    "label": "Dropdown options",
    "empty": "No option groups added yet.",
    "empty_error": "Add at least one option group",
    "group": "Option group",
    "remove_group": "Remove group",
    "group_name": "Group name",
    "group_name_hint": "Optional. Leave blank to list the options without a group heading.",
    "group_name_placeholder": "e.g. Europe",
    "no_options": "No options in this group yet.",
    "no_options_error": "Add at least one option",
    "option_value": "Value",
    "option_value_placeholder": "e.g. eu",
    "option_value_required": "Value is required",
    "option_label": "Label",
    "option_label_placeholder": "e.g. Europe",
    "remove_option": "Remove option",
    "add_option": "Add option",
    "add_group": "Add group"
  },
  "sortable_list": {
    "drag_handle": "Drag to reorder"
  }
}
